export default "__VITE_ASSET__IIAfcqnO__"